import { faTimer } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Header } from 'components/Layout/Header/Header';
import { useMarketplace } from 'hooks/useMarketplace';
import React from 'react';

import classes from './LinkExpired.module.scss';
import { PoweredByCuddles } from './PoweredBy/PoweredByCuddles';

export const LinkExpired: React.FC = () => {
    const marketplace = useMarketplace();

    return (
        <div className={classes.root}>
            <Header logo={marketplace.logo} />

            <div className={classes.content}>
                <div className={classes.iconCircle}>
                    <FontAwesomeIcon icon={faTimer} className={classes.icon} />
                </div>

                <h1 className={classes.title}>This link has expired.</h1>

                <p className={classes.message}>
                    Please contact the business to receive a new form.
                </p>
            </div>

            <div className={classes.footer}>
                <PoweredByCuddles />
            </div>
        </div>
    );
};
